import axios from "axios";

export default class CompaniesService {
  static async getCompaniesByClientId(clientId) {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/companies/by-client/${clientId}`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching companies by client ID:", error.message);
      throw error;
    }
  }

  static async createCompany(companyData) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/companies/create`,
        companyData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating company:", error);
      throw error;
    }
  }

  // Update these methods in your CompaniesService class

  static async updateCompany(companyId, updateData) {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/companies/${companyId}`,
        updateData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating company:", error);
      throw error;
    }
  }

  static async deleteCompany(companyId) {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/companies/${companyId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting company:", error);
      throw error;
    }
  }

  static async deleteFacture(companyId, factureName) {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/companies/${companyId}/remove-facture`,
        { factureName }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting facture:", error);
      throw error;
    }
  }

  static async updateFacturesStatus(companyId, factures) {
    const cleanedFactures = factures.map(({ path, paiement, livraison }) => ({
      path,
      paiement,
      livraison,
    }));

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/companies/${companyId}/update-factures-status`,
        { factures: cleanedFactures }
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour des statuts :", error);
      throw error;
    }
  }

  static async getFacturesStatus(clientId) {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/companies/factures-status/${clientId}`
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération du statut des factures :",
        error
      );
      throw error;
    }
  }
}
